/** Batch event-driven reconciliation without overlapping requests or postponing forever. */
export function coalescedRefresh(refresh: () => Promise<unknown>, signal: AbortSignal) {
  let timer: ReturnType<typeof setTimeout> | undefined;
  let running = false;
  let dirty = false;
  const schedule = () => {
    if (signal.aborted || running || timer !== undefined || !dirty) return;
    timer = setTimeout(() => {
      timer = undefined;
      if (signal.aborted) return;
      dirty = false;
      running = true;
      void refresh()
        .catch(() => undefined)
        .finally(() => {
          running = false;
          schedule();
        });
    }, 500);
  };
  signal.addEventListener(
    "abort",
    () => {
      clearTimeout(timer);
      timer = undefined;
      dirty = false;
    },
    { once: true },
  );
  return () => {
    if (signal.aborted) return;
    dirty = true;
    schedule();
  };
}
